import React from 'react';
import styled from '@tanium/react-emotion';
import { Stack } from '@tanium/react-stack';
import { css } from '@tanium/style-system';

const Container = styled('div')(
  css({
    marginBottom: -1,
    flexWrap: 'wrap',
  }),
);

const ButtonWrapper = styled('div')(
  css({
    marginBottom: 1,
  }),
);

export interface Props {
  children?: React.ReactNode;
}

/**
 * A container that takes individual button or button-like elements as its
 * children and applies appropriate styles to each immediate child.
 */
export const ResultsActionsContainer = ({ children }: Props) => (
  <Stack itemSpacing={1} component={Container} itemComponent={ButtonWrapper}>
    {children}
  </Stack>
);
